import { render, staticRenderFns } from "./salesAvgBeneathList.vue?vue&type=template&id=ec6cabce"
import script from "./salesAvgBeneathList.vue?vue&type=script&lang=js"
export * from "./salesAvgBeneathList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports